// extracted by mini-css-extract-plugin
export default {"list":"NavigationList_list__gdBRU","item":"NavigationList_item__5qqFy","link":"NavigationList_link__c5KuW"};